import * as THREE from 'three';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { SSAARenderPass } from 'three/examples/jsm/postprocessing/SSAARenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { CopyShader } from 'three/examples/jsm/shaders/CopyShader.js';
const renderer = new THREE.WebGLRenderer({antialias: true});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.toneMappingExposure = 4;
window.addEventListener('resize', ()=>{
    camera.aspect = window.innerWidth/window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
    composer.setSize(window.innerWidth, window.innerHeight);

});
renderer.domElement.style.position = "fixed";
document.body.appendChild(renderer.domElement);
const fov = 75;
const aspect = window.innerWidth/window.innerHeight;
const near = 0.1;
const far = 1000;
const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
camera.position.z = 5;
const scene = new THREE.Scene();

const cubeGeometry = new THREE.BoxGeometry(1, 1, 1);
const redMaterial = new THREE.MeshPhongMaterial({color : 0xFF0000, wireframe:true, wireframeLinewidth: 3});
const greenMaterial = new THREE.MeshPhongMaterial({color : 0x00FF00, wireframe:true, wireframeLinewidth: 3});
const blueMaterial = new THREE.MeshPhongMaterial({color:0x1122FF, wireframe:true, wireframeLinewidth: 3});
const sphereGeometry = new THREE.IcosahedronGeometry(1);
const pyramidGeometry = new THREE.TetrahedronGeometry(1);
const pyramid = new THREE.Mesh(pyramidGeometry, blueMaterial);
const cube = new THREE.Mesh(cubeGeometry, greenMaterial);
const sphere = new THREE.Mesh(sphereGeometry, redMaterial);
sphere.position.z = 5;
pyramid.position.z = 5;
sphere.position.x = -4;
pyramid.position.x = 4;



cube.position.z = 5;
sphere.position.y = 1;
cube.position.y = 1;
pyramid.position.y = 1;
scene.add(cube);
scene.add(pyramid);
scene.add(sphere);


const color = 0xFFFFFF;
const intensity = 1;
const light = new THREE.DirectionalLight(color, intensity);
light.position.set(-1, 2, 4);
scene.add(light);
const ambient = new THREE.AmbientLight(0xaaaaaa); 
scene.add( ambient);
var raycaster = new THREE.Raycaster();
var mouse = new THREE.Vector2();
var t1 = gsap.timeline();
t1.to(cube.position, {duration: 2, z: -3});
t1.to(pyramid.position, {duration: 2, z: -3}, "=-2.0");
t1.to(sphere.position, {duration: 2, z: -3}, "=-2.0");


function onMouseMove(event){
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    
}

function transition(event){
    
    gsap.to(camera.rotation, {duration: .5, y: -100*(Math.PI/180)});
    gsap.to("#title", {duratino: 1, xPercent:-100});
    gsap.to(".nav", {duratino: 1, xPercent:-200});
    setTimeout(function () {
        window.location.href = "about.html"; 
    }, 500);
}

var composer = new EffectComposer(renderer);
var renderPass = new SSAARenderPass(scene, camera, 0x000000, 0x000000);
var bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 3, .6, 0);
var effectCopy = new ShaderPass(CopyShader);
composer.addPass(renderPass);
composer.addPass(bloomPass);
composer.addPass(effectCopy);


document.addEventListener('mousemove', onMouseMove);
//document.getElementById("About").addEventListener('click', transition);

function render(time){
    time *= 0.0005;
    cube.rotation.x = time;
    cube.rotation.y = time;
    pyramid.rotation.x = time;
    pyramid.rotation.y = time;
    sphere.rotation.x = time;
    sphere.rotation.y = time;
    raycaster.setFromCamera(mouse, camera);
    
    function tween(object){
        if (raycaster.intersectObject(object).length>0){
            gsap.to(object.scale, {duration: 1, x:1.4});
            gsap.to(object.scale, {duration: 1, y:1.4});
            gsap.to(object.scale, {duration: 1, z:1.4});
        }else{
            gsap.to(object.scale, {duration: 1, x: 1});
            gsap.to(object.scale, {duration: 1, y: 1});
            gsap.to(object.scale, {duration: 1, z: 1});
        }
    }
    tween(cube);
    tween(pyramid);
    tween(sphere);
    if(document.getElementById("title")!=null)
        document.getElementById("title").style.filter = "hue-rotate("+time*50+"deg)";

    composer.render();
    requestAnimationFrame(render);
}
requestAnimationFrame(render);


